// extracted by mini-css-extract-plugin
export default {"arrow":"Arrows_arrow__btUU6","invisible":"Arrows_invisible__L292l"};